import {
  Trash2, Droplets, Leaf, Sprout, Snowflake, Shovel, Flower2, Trees, Sun, Wind,
} from "lucide-react";

export const ICONS = { Trash2, Droplets, Leaf, Sprout, Snowflake, Shovel, Flower2, Trees, Sun, Wind };

export const ICON_NAMES = Object.keys(ICONS);

export const DEFAULT_SERVICE_IMAGE =
  "https://images.unsplash.com/photo-1782613064276-750c3a3ccdec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxsYXduJTIwbW93aW5nJTIwZ2FyZGVuJTIwbGVhZiUyMGNsZWFudXAlMjB5YXJkJTIwd29yayUyMG91dGRvb3J8ZW58MHx8fHwxNzkwNjI4NzUwfDA&ixlib=rb-4.1.0&q=85";

// Fallback copy shown only until the live service list loads from the API.
export const SERVICES = [
  {
    id: "trash-bin",
    name: "Trash Bin Cleaning",
    price: "$15 per bin",
    blurb: "Pressure-wash your trash bins to help keep them cleaner and fresher.",
    details:
      "We clean the inside and outside of your bin and help remove built-up dirt and grime. Final pricing is based on the number of bins.",
    image:
      "https://images.unsplash.com/photo-1782511295240-2d55c11776ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxyZWN5Y2xlJTIwYmluJTIwdHJhc2glMjBjYW4lMjBvdXRkb29yJTIwc3VidXJiYW4lMjBob3VzZSUyMGxhd258ZW58MHx8fHwxNzkwNjI4NzU4fDA&ixlib=rb-4.1.0&q=85",
    icon: "Trash2",
  },
  {
    id: "pressure-washing",
    name: "Pressure Washing",
    price: "$75 minimum",
    blurb: "Clean dirty driveways and outdoor surfaces with pressure washing.",
    details:
      "Driveway and outdoor-surface pressure washing. Jobs start at $75, with larger or more difficult jobs quoted based on size and condition.",
    image:
      "https://images.unsplash.com/photo-1781637202423-33ec5b47e52e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxwcmVzc3VyZSUyMHdhc2hpbmclMjBkcml2ZXdheSUyMGNsZWFuJTIwd2F0ZXIlMjBzcGxhc2h8ZW58MHx8fHwxNzkwNjI4NzUwfDA&ixlib=rb-4.1.0&q=85",
    icon: "Droplets",
  },
  {
    id: "leaf-cleanup",
    name: "Leaf Cleanup",
    price: "Starting at $40",
    blurb: "Raking, gathering, and cleanup of leaves around your property.",
    details:
      "We rake and gather fallen leaves and clean up the work area. Pricing starts at $40 and can vary with property size and amount of leaves.",
    image:
      "https://images.unsplash.com/photo-1742093325645-a48a96f82c84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxsYXduJTIwbW93aW5nJTIwZ2FyZGVuJTIwbGVhZiUyMGNsZWFudXAlMjB5YXJkJTIwd29yayUyMG91dGRvb3J8ZW58MHx8fHwxNzkwNjI4NzUwfDA&ixlib=rb-4.1.0&q=85",
    icon: "Leaf",
  },
  {
    id: "yard-cleanup",
    name: "Yard Cleanup",
    price: "Starting at $45",
    blurb: "Sticks, weeds, leaves, and other outdoor debris cleaned up.",
    details:
      "Great for seasonal cleanups. We can rake leaves, gather sticks, pull weeds, and clean up outdoor debris. Starts at $45.",
    image:
      "https://images.unsplash.com/photo-1782613064276-750c3a3ccdec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxsYXduJTIwbW93aW5nJTIwZ2FyZGVuJTIwbGVhZiUyMGNsZWFudXAlMjB5YXJkJTIwd29yayUyMG91dGRvb3J8ZW58MHx8fHwxNzkwNjI4NzUwfDA&ixlib=rb-4.1.0&q=85",
    icon: "Sprout",
  },
  {
    id: "snow-removal",
    name: "Snow Removal",
    price: "Starting at $30",
    blurb: "Help clearing snow from driveways, sidewalks, and other areas.",
    details:
      "We help clear snow from residential driveways, sidewalks, and other accessible areas. Starts at $30 and depends on the amount of snow and area size.",
    image:
      "https://images.unsplash.com/photo-1704578424157-223c3ad72870?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxzbm93JTIwc2hvdmVsJTIwZHJpdmV3YXklMjB3aW50ZXIlMjBob3VzZSUyMHNub3clMjByZW1vdmFsfGVufDB8fHx8MTc5MDYyODc1OXww&ixlib=rb-4.1.0&q=85",
    icon: "Snowflake",
  },
];

export const SEASON_META = {
  spring: { label: "Spring", dot: "#65A30D", services: ["yard-cleanup", "pressure-washing"] },
  summer: { label: "Summer", dot: "#84CC16", services: ["trash-bin", "pressure-washing"] },
  autumn: { label: "Autumn", dot: "#B45309", services: ["leaf-cleanup", "yard-cleanup"] },
  winter: { label: "Winter", dot: "#0284C7", services: ["snow-removal"] },
};

export const SEASON_ORDER = ["spring", "summer", "autumn", "winter"];

export const currentSeason = () => {
  const m = new Date().getMonth();
  if (m >= 2 && m <= 4) return "spring";
  if (m >= 5 && m <= 7) return "summer";
  if (m >= 8 && m <= 10) return "autumn";
  return "winter";
};
